// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 500ms ease-in-out;
  flex-flow: column;
  margin: 0 !important;
  overflow: hidden;
}
.loader--absolute {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  z-index: 10;
  background-color: #000;
}
.loader--absolute::after {
  content: "";
  display: block;
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  pointer-events: none;
  transition: opacity 500ms ease-in-out;
}
.loader--visible {
  pointer-events: inherit;
  opacity: 1;
  align-self: center;
}
.loader--visible::after {
  opacity: 0.8;
  pointer-events: inherit;
}
.loader .loadingContainer {
  position: relative;
  width: min(100%, 120vh);
  width: min(100%, 120svh);
  max-width: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.loader .loadingContainer #mainLoaderText {
  position: absolute;
  top: 24.8%;
  left: 50%;
  transform: translateX(-50%);
  font-size: min(6vw, 7vh, 60px);
  font-weight: bold;
  text-align: center;
  color: #ffe3a8;
}
.loader .loadingContainer .eyeLogo {
  display: block;
  width: 70%;
}
.loader .loadingContainer .clickToStart {
  display: none;
  width: 70%;
}
.loader .loadingContainer .clickToStartText {
  display: none;
  position: absolute;
  top: 76.5%;
  color: #f0ca6f;
  font-family: DinCondensed;
  text-transform: uppercase;
  font-size: min(5vw, 6vh, 50px);
}
.loader .loadingContainer .wheelShine {
  position: absolute;
  top: -11.6%;
  width: 54.4%;
  visibility: hidden;
}
.loader .loadingContainer .wheelShine.pos-1 {
  rotate: -120deg;
  visibility: hidden;
}
.loader .loadingContainer .wheelShine.pos-2 {
  rotate: -240deg;
  visibility: hidden;
}
.loader .loadingContainer .loadingLine {
  position: absolute;
  top: 74.4%;
  width: 0;
  max-width: 84%;
  height: 23%;
}
`, "",{"version":3,"sources":["webpack://./src/core/template/loader.less"],"names":[],"mappings":"AAGA;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,qCAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AAFJ;AAII;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAFR;AAGQ;EACI,WAAA;EACA,cAAA;EACA,UAAA;EAEA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,oBAAA;EACA,qCAAA;AAFZ;AAMI;EACI,uBAAA;EACA,UAAA;EACA,kBAAA;AAJR;AAMQ;EACI,YAAA;EACA,uBAAA;AAJZ;AAtCA;EA+CQ,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AANR;AAhDA;EAyDY,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AANZ;AA1DA;EAoEY,cAAA;EACA,UAAA;AAPZ;AA9DA;EAyEY,aAAA;EACA,UAAA;AARZ;AAlEA;EA8EY,aAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;AATZ;AA3EA;EAwFY,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAVZ;AAYY;EACI,eAAA;EACA,kBAAA;AAVhB;AAYY;EACI,eAAA;EACA,kBAAA;AAVhB;AAzFA;EAwGY,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;AAZZ","sourcesContent":["@primary: #000;\n@secondary: #FFF;\n\n.loader {\n    pointer-events: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 500ms ease-in-out;\n    flex-flow: column;\n    margin: 0 !important;\n    overflow: hidden;\n\n    &--absolute {\n        position: absolute;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        right: 0;\n        height: 100%;\n        z-index: 10;\n        background-color: @primary;\n        &::after {\n            content: \"\";\n            display: block;\n            opacity: 0;\n            transition: opacity 500ms ease-in-out;\n            position: absolute;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            top: 0;\n            pointer-events: none;\n            transition: opacity 500ms ease-in-out;\n        }\n    }\n\n    &--visible {\n        pointer-events: inherit;\n        opacity: 1;\n        align-self: center;\n\n        &::after {\n            opacity: 0.8;\n            pointer-events: inherit;\n        }\n    }\n\n    .loadingContainer {\n        position: relative;\n        width: min(100%, 120vh);\n        width: min(100%, 120svh);\n        max-width: 1000px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n\n        #mainLoaderText {\n            position: absolute;\n            top: 24.8%;\n            left: 50%;\n            transform: translateX(-50%);\n            font-size: min(6vw, 7vh, 60px); \n            font-weight: bold;\n            text-align: center;\n            color: #ffe3a8;\n        }\n\n        .eyeLogo {\n            display: block;\n            width: 70%;\n        }\n\n        .clickToStart {\n            display: none;\n            width: 70%;\n        }\n\n        .clickToStartText {\n            display: none;\n            position: absolute;\n            top: 76.5%;\n            color: #f0ca6f;\n            font-family: DinCondensed;\n            text-transform: uppercase;\n            font-size: min(5vw, 6vh, 50px);\n        }\n\n        .wheelShine {\n            position: absolute;\n            top: -11.6%;\n            width: 54.4%;\n            visibility: hidden;\n\n            &.pos-1 {\n                rotate: -120deg;\n                visibility: hidden;\n            }\n            &.pos-2 {\n                rotate: -240deg;\n                visibility: hidden;\n            }\n        }\n\n        .loadingLine {\n            position: absolute;\n            top: 74.4%;\n            width: 0;\n            max-width: 84%;\n            height: 23%;\n        }\n    }\n}\n@imgPath: 'undefined';"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
